import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import SelectOfferDialogCriteria from './SelectOfferDialog.criteria'

import { onSetCriteriaPurchaseOrder, onSetValidationInputGroup } from './SelectOfferDialog.actions'

import { Grid, SubHeader, RowScroll } from './SelectOfferDialog.styles'

import { SELECTION_CRITERIA_DICTIONARY } from '../../config/settings/constants'

/**
 * The SelectOfferDialogList's component.
 */
const SelectOfferDialogList = memo(props => {
  const { currency, offerSelected, onChanges } = props

  const dispatch = useDispatch()

  const { selectionCriteria, isOfferLowerPrice, selectedOffers } = useSelector(state => state.selectOfferDialog)

  const selectionCriteriaOrdered = [...selectionCriteria].sort((a, b) => {
    if (a.order === b.order) {
      return 0
    }
    return a.order > b.order ? 1 : -1
  })

  const handleRadioList = radioSelected => {
    const { codeRadio, id, text, error } = radioSelected

    if (codeRadio === SELECTION_CRITERIA_DICTIONARY.OTHER && text === '') {
      dispatch(onSetValidationInputGroup({ id, validation: false }))
    }

    dispatch(
      onSetCriteriaPurchaseOrder({
        offer: id,
        selectionCriteria: { text, idCriteria: codeRadio }
      })
    )
    dispatch(onSetValidationInputGroup({ id, validation: true }))

    onChanges(error)
  }

  return (
    <>
      {!isOfferLowerPrice && selectedOffers.length === 1 && (
        <Grid container margin="20px 0 0 ">
          <SubHeader>Criterio:</SubHeader>
          <SelectOfferDialogCriteria
            currency={currency}
            offer={offerSelected[0]}
            onChangesRadio={handleRadioList}
            criteria={selectionCriteriaOrdered}
          />
        </Grid>
      )}
      {selectedOffers.length > 1 && (
        <RowScroll>
          {offerSelected.map((offer, index) => (
            <SelectOfferDialogCriteria
              currency={currency}
              key={index}
              offer={offer}
              onChangesRadio={handleRadioList}
              criteria={selectionCriteriaOrdered}
              activeSelectMulti
            />
          ))}
        </RowScroll>
      )}
    </>
  )
})

SelectOfferDialogList.defaultProps = {
  currency: 'CLP'
}

SelectOfferDialogList.propTypes = {
  currency: PropTypes.string,
  offerSelected: PropTypes.array,
  onChanges: PropTypes.func
}

export default SelectOfferDialogList
